export default __webpack_public_path__ + "static/media/XHighlight Process - Equal.de88743c.png";